import EventTile from './EventTile';

export default EventTile;
